export const defineCreateBeneficiarySuccessMessage = (name: string) =>
  `Beneficiary ${name} has been added successfully`;
